import { render, staticRenderFns } from "./HomeNewsCarousel.vue?vue&type=template&id=d14f4754&"
import script from "./HomeNewsCarousel.vue?vue&type=script&lang=js&"
export * from "./HomeNewsCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports